import React, {useState, useRef} from "react";
import {BlockContainer} from "BaseComponents/Wrappers";
import {GetTextColor} from "Helpers/ColorHelper";
import {H2, H3} from "BaseComponents/Text";
import Select from "react-select";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styled, {css} from "styled-components";
import {FlexContainer} from "BaseComponents/Flex";
import {useGlobal} from "reactn";
import {ButtonText, SubmitButton} from "BaseComponents/Button";
import {DPwrapper} from "./BookingDatePickerTheme";
import isBefore from 'date-fns/isBefore';
import format from 'date-fns/format';
import formatDistance from 'date-fns/formatDistance'
import media from "styled-media-query";
import breakpoints from "Framework/helpers/BreakpointHelper/BreakpointHelper";
import {FormCounter} from "../../BaseComponents/Form/Counter";
import {PseudoSelect} from "../../BaseComponents/Form/Select";
import useBreakpoint from "Hooks/useBreakpoint";

export const HotelBookingBlock = ({
                                      Heading,
                                      Subtitle,
                                      BackgroundColor,
                                      ButtonColor,
                                      ButtonTitle,
                                      CheckInLabel,
                                      CheckOutLabel,
                                      SelectHotelLabel,
                                      PersonsLabel,
                                      NumberOfRoomsLabel,
                                      Hotels,
                                      SelectLabel
                                  }) => {
    const [selectedHotel, setSelectedHotel] = useState(null);
    const [checkInDate, setCheckInDate] = useState(null);
    const [checkOutDate, setCheckOutDate] = useState(null);
    const [showCalendar, setShowcalendar] = useState(true);
    const [showRooms, setShowRooms] = useState(false);
    const [showPeople, setPeople] = useState(false);
    const [hotelUrl, setHotelUrl] = useState(null);
    const [roomCount, setRoomCount] = useState(1);
    const [adult, setAdult] = useState(1);
    const [children, setChildren] = useState(0);
    const [infant, setInfant] = useState(0);
    const checkInDateRef = useRef(null);
    const checkOutDateRef = useRef(null);
    const selectRef = useRef(null);
    const [theme] = useGlobal("theme");
    const {textColor} = GetTextColor(BackgroundColor);
    const hotelOptions = Hotels?.map((option) => ({label: option.Title, value: option.Title}));
    const isMobile = useBreakpoint("mobile");

    const submitHandle = (e) => {
        e.preventDefault();
        const invalidDateStyle = 'border: 0.063rem solid red';
        const correctDateStyle = 'border: 0.063rem solid #949494';

        if (!selectedHotel || (showCalendar && (!checkInDate || !checkOutDate))) {
            if (!checkInDate) checkInDateRef.current.input.style = invalidDateStyle;
            if (!checkOutDate) checkOutDateRef.current.input.style = invalidDateStyle;
            if (!selectedHotel) selectRef.current.select.controlRef.style = invalidDateStyle;
            return false;
        }
        let nightsCount = 0;
        if (showCalendar) {
            const dates = formatDistance(checkInDate, checkOutDate);
            nightsCount = dates.split(' ')[0];
        }

        let hotelParams = '';

        if (showCalendar) {
            hotelParams = `?date=${format(checkInDate, "dd.MM.yyyy")}&nights=${nightsCount}`
        }
        if (showPeople) {
            hotelParams = `${hotelParams}${showCalendar ? '&' : '?'}childBAB=${infant}&childCHI=${children}&adults=${adult}`;
        }
        if (showRooms) {
            hotelParams = `${hotelParams}${showCalendar || showPeople ? '&' : '?'}rooms=${roomCount}`;
        }

        let hotelDeepLink = hotelUrl ? `${hotelUrl}${hotelParams}` : null;

        if (showCalendar && (checkInDate || checkOutDate)) {
            checkInDateRef.current.input.style = correctDateStyle;
            checkOutDateRef.current.input.style = correctDateStyle;
        }
        selectRef.current.select.controlRef.style = correctDateStyle;

        if (hotelDeepLink) window.open(hotelDeepLink, '_blank', 'noopener,noreferrer');
    }

    const onHotelChange = (hotel) => {
        const hotelIndex = Hotels.findIndex(hotelItem => hotelItem.Title === hotel.value);
        const {BookingUrl, ShowDateRange, ShowRoomSelection, ShowPeopleSelection} = Hotels[hotelIndex];
        setPeople(ShowPeopleSelection);
        setShowRooms(ShowRoomSelection);
        setShowcalendar(ShowDateRange);
        setSelectedHotel(hotel.value);
        setHotelUrl(BookingUrl);
    }

    const onChangeCheckIn = (date) => {
        if (checkOutDate) {
            setCheckInDate(date);
            const checkOutIsBefore = isBefore(checkOutDate, date);
            if (checkOutIsBefore) {
                const startDate = new Date(date);
                setCheckOutDate(startDate.setDate(startDate.getDate() + 1));
            }
            return;
        }
        setCheckInDate(date);
    }

    const colourStyles = {
        dropdownIndicator: (styles) => {
            return {...styles, color: '#000', fontSize: '1.125rem'}
        },
        placeholder: (styles) => {
            return {...styles, color: '#000', fontSize: '1.125rem', fontFamily: theme.font}
        },
        singleValue: (styles) => {
            return {...styles, color: '#000', fontSize: '1.125rem', fontFamily: theme.font}
        },
        control: (styles) => {
            return {
                ...styles,
                backgroundColor: '#fff',
                height: '3rem',
                borderRadius: '3.438rem',
                border: '0.063rem solid #949494'
            }
        },
        option: (styles, {isDisabled, isSelected}) => {
            return {
                ...styles,
                backgroundColor: isSelected ? theme.colors.primary : '#fff',
                color: isSelected ? '#fff' : '#000',
                fontWeight: 700,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                fontFamily: theme.font,
                zIndex: 3,
                ":hover": {
                    backgroundColor: theme.colors.primary,
                    color: '#fff',
                },
                ':active': {
                    ...styles[':active'],
                    backgroundColor: theme.colors.primary,
                }
            };
        },
    };

    const disabledSearch = !selectedHotel?.length;

    const counterCallback = (data) => {
        switch (data?.field) {
            case 'room':
                setRoomCount(data.count);
                return;
            case 'adults':
                setAdult(data.count);
                return;
            case 'children':
                setChildren(data.count);
                return;
            case 'infant':
                setInfant(data.count);
                return;
        }
    }

    return (
        <BlockContainer bgColor={`#${BackgroundColor}`}>
            <FlexContainer
                flexwrap="wrap"
                maxwidth={theme.grid.outer}
                alignItems="center"
                justifyContent="center"
                margin="0 auto"
                padding="0 3.625rem"
            >
                {Heading ? <HeadingWrap><H2 textAlign="center" color={textColor}>{Heading}</H2></HeadingWrap> : null}
                {Subtitle ? <HeadingWrap margin="0.313rem 0 0"><H3 margin="0" textAlign="center"
                                                                   color={textColor}>{Subtitle}</H3></HeadingWrap> : null}

                <Form onSubmit={submitHandle}>
                    <FormFlex>
                        <FormFieldsWrapper>
                            <FieldWrapper flexItem="3 1 0">
                                <Label>{SelectHotelLabel}</Label>
                                <Select
                                    ref={selectRef}
                                    className="booking-select"
                                    aria-label={Heading}
                                    isSearchable={false}
                                    options={hotelOptions}
                                    onChange={onHotelChange}
                                    styles={colourStyles}
                                    placeholder={SelectLabel}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                />
                            </FieldWrapper>
                            {!isMobile ? <FieldWrapper>
                                <SubmitButtonWrapper buttonColor={ButtonColor}>
                                    <SubmitButton
                                        widthsmall="100%"
                                        padding="0.657rem"
                                        width="218px"
                                        borderRadius="55px"
                                        margin="0"
                                        type="submit"
                                        disabled={disabledSearch}
                                        disabledcolor={`${theme.colors.primary}`}
                                        opacity={disabledSearch ? 0.6 : 1}
                                    >
                                        <ButtonText color={'red'} textTransform="uppercase"
                                                    heading={Heading}>{ButtonTitle}</ButtonText>
                                    </SubmitButton>
                                </SubmitButtonWrapper>
                            </FieldWrapper> : null}
                        </FormFieldsWrapper>
                        <FormFieldsWrapper>
                            {selectedHotel && showCalendar ? (<>
                                    <FieldWrapper>
                                        <Label>{CheckInLabel}</Label>
                                        <DPwrapper>
                                            <i className="fa-light fa-calendar-days" aria-hidden="true"></i>
                                            <ReactDatePicker
                                                ref={checkInDateRef}
                                                dateFormat="yyyy-MM-dd"
                                                onChange={onChangeCheckIn}
                                                name={'checkIn'}
                                                selected={checkInDate}
                                                autoComplete="Off"
                                                calendarClassName="bookingDates"
                                                popperClassName="bookingPopper"
                                                minDate={new Date()}
                                                popperPlacement="bottom"
                                            />
                                        </DPwrapper>
                                    </FieldWrapper>
                                    <DateSeparate>-</DateSeparate>
                                    <FieldWrapper>
                                        <Label>{CheckOutLabel}</Label>
                                        <DPwrapper>
                                            <i className="fa-light fa-calendar-days" aria-hidden="true"></i>
                                            <ReactDatePicker
                                                ref={checkOutDateRef}
                                                dateFormat="yyyy-MM-dd"
                                                onChange={(date) => setCheckOutDate(date)}
                                                name={'checkOut'}
                                                selected={checkOutDate}
                                                autoComplete="Off"
                                                calendarClassName="bookingDates"
                                                popperClassName="bookingPopper"
                                                minDate={checkInDate}
                                                popperPlacement="bottom"
                                            />
                                        </DPwrapper>
                                    </FieldWrapper>
                                </>)
                                : null}
                            {selectedHotel ? <FieldWrapper flexItem={'2 1 0'} dFlex>
                                {showPeople ? <PseudoSelect label={PersonsLabel} counterCallback={counterCallback}
                                                            initialAdult={adult}
                                                            initialChildren={children} initialInfant={infant}/> : null}
                                {showRooms ? <FormCounter label={NumberOfRoomsLabel} initialCount={roomCount}
                                                          counterCallback={counterCallback} name="room"
                                                          minAmount={1}/> : null}
                            </FieldWrapper> : null}
                            {isMobile ? <FieldWrapper>
                                <SubmitButtonWrapper buttonColor={ButtonColor}>
                                    <SubmitButton
                                        widthsmall="100%"
                                        padding="0.657rem"
                                        width="218px"
                                        borderRadius="55px"
                                        margin="0"
                                        type="submit"
                                        disabled={disabledSearch}
                                        disabledcolor={`${theme.colors.primary}`}
                                        opacity={disabledSearch ? 0.6 : 1}
                                    >
                                        <ButtonText color={'red'} textTransform="uppercase"
                                                    heading={Heading}>{ButtonTitle}</ButtonText>
                                    </SubmitButton>
                                </SubmitButtonWrapper>
                            </FieldWrapper> : null}
                        </FormFieldsWrapper>
                    </FormFlex>
                </Form>
            </FlexContainer>
        </BlockContainer>
    );
};

const Form = styled.form`
  margin-top: 2rem;
  padding: 1rem;
  background-color: #fff;
  border-radius: 0.625rem;
  border-top: 3px solid ${({theme}) => theme.colors.primary};

  ${media.greaterThan(breakpoints.mobile)`&{
		    padding: 2.5rem 7rem;
	    }`
  }
`;

const Label = styled.label`
  display: flex;
  font-weight: 700;
  width: 100%;
  margin-bottom: 0.625rem;
`;

const HeadingWrap = styled.div.attrs(({margin}) => ({
    margin: margin ? margin : '0.313rem 0',
}))`
  width: 100%;
  margin: 0.313rem 0;
  ${media.greaterThan(breakpoints.desktop)`&{
        margin: ${({margin}) => margin};
        h3 {
            font-size: 1.375rem;
        }
    }`
  }
`;

const FormFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 1.5rem;

  ${media.greaterThan(breakpoints.mobile)`&{
            flex-direction: row;
            flex: 1 1 100%;
            ${media.lessThan(breakpoints.ipad)`&{
                flex-direction: column;
            }`
  }`
  }
`;

const FieldWrapper = styled.div.attrs(({flexItem}) => ({
    flex: flexItem ? flexItem : '1 1 0',
}))`
  ${({dFlex}) =>
          dFlex &&
          css`
            display: flex;
            gap: 24px;
          `}
  width: 100%;
  flex: 1 1 0;

  ${media.greaterThan(breakpoints.mobile)`&{
        flex: ${({flex}) => flex};
    }`
  }
  ${media.lessThan(breakpoints.mobile)`
        flex-direction: column;
    `}
  .booking-select {
    z-index: 2;
  }
`;

const DateSeparate = styled.div`
  display: none;
  justify-content: center;
  color: #949494;
  margin-bottom: 0.875rem;
  font-size: 1.125rem;
  font-weight: 700;
  ${media.greaterThan(breakpoints.mobile)`&{
            display: flex;
            ${media.lessThan(breakpoints.ipad)`&{
                display: none;
            }`
  }`
  }
`;

const SubmitButtonWrapper = styled.div.attrs(({buttonColor, theme}) => ({
    buttonColor: buttonColor ? `#${buttonColor}` : theme.colors.primary
}))`
  button {
    height: 3rem;
    background: ${({buttonColor}) => buttonColor};
    font-weight: 600;
    border: 0.063rem solid ${({buttonColor}) => buttonColor};

    &:hover {
      background: #fff;
      border: 0.063rem solid ${({buttonColor}) => buttonColor};
    }

    &:focus {
      outline: none;
    }
  }
`;

const FormFlex = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 25px;

  ${media.lessThan(breakpoints.mobile)`
        flex-direction: column;
    `}
`
